import { Box } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import React from "react";

interface LoaderProps {
  "data-testid"?: string;
}

export const Loader: React.FC<LoaderProps> = (props) => {
  return (
    <Box mb={37} {...props}>
      <Box width="131px" mb={3}>
        <Skeleton variant="text" component="span" animation="wave" />
      </Box>
      <Box width="531px" mb={3}>
        <Skeleton variant="text" component="span" animation="wave" />
      </Box>
      <Box width="531px" mb={3}>
        <Skeleton variant="text" component="span" animation="wave" />
      </Box>
    </Box>
  );
};
